<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import FileBox from '../common/FileBox.vue'

import { getShadowColor, getFileTypeLogo } from '@/utils/modules/getStyles'
import { getFileType } from '@/utils/common.js'
import { hiddenPhone } from '@/utils/filters'

export default {
  name: 'Comp4',
  components: { ModuleTitle, FileBox },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      pageData: []
    }
  },
  created() {
    this.dataValued()
  },
  methods: {
    hiddenPhone,
    getShadowColor, getFileTypeLogo, getFileType,
    onPhoneHidden(v) {
      this.pageData.forEach(item => {
        if (item.id === v.id) item.phoneShow = !item.phoneShow
      })
    },
    dataValued() {
      this.pageData = this.moduleOption?.list || []
      this.pageData.length > 0 && this.pageData.forEach(item => {
        this.$set(item, 'phoneShow', false)
      })
    }
  }
}
</script>

<template>
  <div class="modules-id-4">
    <module-title :title="moduleOption.title" margin-bottom="30" />
    <div class="comp-transverse-3 modules-id-4-content">
      <div v-for="(v, i) in pageData.slice(0, 3)" :key="`modules-4-${i}`">
        <!-- i + 1 !== moduleOption.list.length -->
        <div
          v-if="v.typeid === 0"
          class="item member-item"
          :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}"
        >
          <el-image class="avator" :src="v.photo | imgPath" alt="avator" fit="cover" />
          <div class="item-right">
            <p class="name">{{ `${v.contactgroup || ''}: ${v.name || ''}` }}</p>
            <p class="phone">
              联系方式: {{ v.phone || '-' }}
            </p>
            <!-- <p class="phone">
              联系方式: {{ v.phoneShow ? v.phone : hiddenPhone(v.phone) }}
              <span @click.stop="onPhoneHidden(v)">{{ v.phoneShow ? '隐藏' : '显示' }}</span>
            </p> -->
          </div>
        </div>
        <file-box v-else :headline="v.headline" :filename="v.typename" :createtime="v.createtime" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-4-content {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  .item {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 8px;
  }
  .member-item {
    width: 401px;
    height: 94px;
    border-radius: 5px;
    background: url('~imgs/modules/id-4-comp-bg.png') no-repeat center;
    background-size: 100% 100%;
  }
  .avator {
    width: 59px;
    height: 77px;
    border-radius: 5px;
  }
  .item-right {
    height: 77px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
    margin-left: 20px;
  }
  .name, .phone {
    font-size: 17px;
    font-weight: bold;
    color: #000;
    text-align: center;
  }
  .phone {
    font-size: 15px;
    span {
      color: #999;
      margin-left: 2px;
      cursor: pointer;
    }
  }
}
</style>
